import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { leaveService } from "../../../services/extensions";
import { useSelector } from "react-redux";
import moment from "moment";
import NewAbsenceRequest from "../NewAbsenceRequest";
import { Dialog } from "primereact/dialog";
import { Status, LeaveStatus, LeaveStatusCode } from '../../../common/util/constants';
import { Util } from '../../../services';
import { capitalize } from "../../../services/utility/helper";
const themes = {
    IND: { backgroundColor: '#38bbe6' },
    UK: { backgroundColor: '#86c807' },
    AUS: { backgroundColor: '#dfe700' },
    SIN: { backgroundColor: '#a48fef' },
    PHL: { backgroundColor: '#ffa000' },
    USA: { backgroundColor: '#e929e9' },
    IRL: { backgroundColor: '#d3acc4' }
}
const EventCalendar = () => {
    const { user } = useSelector(state => state.user);
    const localizer = momentLocalizer(moment);
    const [eventsData, setEventsData] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [event, setEvent] = useState({});

    useEffect(() => {
        getHolidays();
    }, []);

    const getHolidays = () => {
        leaveService.getAllHolidaysCalander().then(resp => {
            const holData = resp?.data?.data?.holidays?.map(e => {
                const date = new Date(e.date);
                const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
                const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
                let holidayType = e.type === 'RH' ? 'Restricted Holiday' : 'Public Holiday';
                return {
                    id: 'evt-' + e.id,
                    class: 'he',
                    title: `${capitalize(e.name)} - ${holidayType}`,
                    start: start,
                    end: end,
                    name: e.name,
                    // region: e.region,
                    date: e.date,
                    legalEntity: e.legalEntityId,
                    holidayType: e.type,
                    backgroundColor: themes['IND'].backgroundColor,
                }
            }).flat();
            setEventsData(holData)
        });
    };



    const handleSelect = (data) => {
        // setEvent(data);
        // setShowDialog(true);
    };

    const renderViewEvent = () => {
        return (<>
            <Dialog header="Event Details" visible={showDialog} onHide={() => setShowDialog(false)} style={{ width: '70vw' }}>
                <pre>{JSON.stringify(event, null, 4)}</pre>
            </Dialog>
        </>)
    }
    return (
        <div>
            {renderViewEvent()}
            <Calendar
                views={["day", "work_week", "month"]}
                selectable
                localizer={localizer}
                defaultDate={new Date()}
                defaultView="month"
                events={eventsData}
                style={{ height: "calc(100vh - 230px)" }}
                onSelectEvent={(event) => console.log(event.title)}
                onSelectSlot={handleSelect}
            />
        </div>
    )
}

export default EventCalendar
